<mat-icon class="verification-icon verification-error" *ngIf="document.ocrolusDocTypeVerified === 0" [matTooltip]="ocrolusDocTypeTooltip(document)">warning</mat-icon>
<mat-icon class="verification-icon verification-success" *ngIf="document.ocrolusDocTypeVerified === 1" [matTooltip]="ocrolusDocTypeTooltip(document)">check_circle</mat-icon>
<mat-form-field class="document-categories no-subscript" (click)="$event.stopPropagation()">
    <mat-label>Choose Type</mat-label>
    <input type="text"
        placeholder="Choose Type"
        matInput
        [formControl]="categoryControl"
        [disabled]="disableDocCategory(document)"
        [matAutocomplete]="auto"
        data-cy="doc-type-input">
    <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="handleDocCategory(document, { type: 'category', value: $event.option.value })"
    [panelWidth]="350">
    <mat-option *ngFor="let category of filteredOptions | async; let i = index;" [value]="category.name" attr.data-cy="doc-type-{{category.id}}">
        {{ category.name }}
    </mat-option>
    </mat-autocomplete>
</mat-form-field>
